module.exports = __webpack_public_path__ + "img/slot-game.a011315d.png";